import { render, staticRenderFns } from "./BusinessStatistics.vue?vue&type=template&id=c3a9ee3a"
import script from "./BusinessStatistics.vue?vue&type=script&lang=js"
export * from "./BusinessStatistics.vue?vue&type=script&lang=js"
import style0 from "./BusinessStatistics.vue?vue&type=style&index=0&id=c3a9ee3a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports